(function() {
    'use strict';

    const bodyClass_navOpen = 'body--mobNavOpen';
    const js_iconCrossClass = 'js-iconCross';
    const iconCrossClass = 'iconCross--animate';

    const btnsNavToggle = document.querySelectorAll('.js-navMobileToggle');

    btnsNavToggle.forEach((elm) => {
        elm.addEventListener('click', toggleNav);
    });

    function toggleNav(e) {
        console.log('clicked on' + e.currentTarget);
        document.body.classList.toggle(bodyClass_navOpen);
        if (e.currentTarget.classList.contains(js_iconCrossClass)) {
            e.currentTarget.classList.toggle(iconCrossClass);
        }
        window.scrollTo(0,0);
    }
})();